import type { CSSProperties } from 'react';

/**
 * Keep the Explore EGM list mounted under Details so close preserves scroll /
 * selection and does not remount → refetch. When Details is closed, use
 * `display: contents` so `.box-list` still fills ListSheet `.panel-content`
 * (a plain wrapper without height collapses IonContent → empty list while the
 * map still shows pins). When Details is open, hide the list with `display: none`.
 */
export function exploreListMountStyle(detailsOpen: boolean): CSSProperties {
  return detailsOpen ? { display: 'none' } : { display: 'contents' };
}
